<template>
	<section class="race__details" v-if="details && details.runners">
		<div class="race__details__top">
			<ul class="race__details__container">
				<li v-if="isMobile" class="w-100 mb-2">{{ formatToDate(details.time, 'DD MMMM YYYY [-] H[h]mm') }}</li>
				<li>Heure de départ <b>{{ raceTimeText }}</b></li>
				<li>Partants <b>{{ runners }}</b></li>
				<li>Distance <b>{{details.distance}}m</b></li>
				<li>Corde <b>{{details.tracktype.toLowerCase().replace('corde ', '')}} </b></li>
				<li>
					Discipline
					<b>
						<span class="icon" :class="raceType" aria-hidden="true"></span>
						{{details.racetype}}<!--{{t('racecard.info.race.type.'+details.type) }} -->
					</b>
				</li>
				<li v-if="details.weather_temp !== null">Météo <b><span class="icon" :class="'icon--w-wm-'+details.weather_icon" aria-hidden="true"></span>{{details.weather_temp}}°C </b></li>
				<li v-if="details.trackcondition">Terrain <b>{{ details.trackcondition}}</b></li>
				<li>Allocation <b>{{ formatToMoney(details.purse * 100) }}</b></li>
			</ul>
		</div>
		<div class="race__details__bottom">
			<ul class="race__details__container" v-if="!result">
				<li>
					<span @click="conditions = !conditions" class="pointer">
						<span class="icon icon--info" aria-hidden="true"></span>
						Conditions de la course
					</span>
				</li>
				<!--<li><a href="#"><span class="icon icon&#45;&#45;info" aria-hidden="true"></span>Les pronostics</a></li>-->
			</ul>
			<ul class="race__details__container" v-if="result">
				<li v-if="details.status === 'OFFICIAL'">
					<div class="arriveeDefinitive">
						<div class="fontText">{{t('race.result.title.final.arival')}}</div>
						<div class="boxes">
							<div class="box" :key="'result-key-box--'+r" v-for="r in result.combination">{{r}}</div>
						</div>
					</div>
				</li>
				<li v-if="details.finishtime">

					<div class="tempsDeLaCourse">
						<span class="title">Temps de la course</span>
						<span class="temps">{{details.finishtime}}</span>
					</div>
				</li>
				<!--<li><a href="#"><span class="icon icon&#45;&#45;info" aria-hidden="true"></span>Les pronostics</a></li>-->
			</ul>
			<div class="container">
				<div class="row" v-if="conditions">
					<div class="col-12 col-lg-8 mb-3 mt-3" v-html="details.comment">

					</div>
				</div>
			</div>


		</div>

	</section><!-- /.race__details -->
</template>
<script>
	import Vuex from 'vuex';
	import moment from 'moment-timezone';


	export default {
		name: 'RaceDetails',
		props: [
			'details',
			'result'
		],
		components: {},
		data() {
			return {
				conditions: false,


			}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			raceTimeText() {
				if (this.details) {
					return moment(this.details.time).format('H[h]mm')
				}
			},
			runners(){
				let runners = 0;
				this.details.runners.forEach((runner)=>{
					if(runner.status || (!runner.status && runner.startnr <= 100)){
						runners++;
					}
				});

				return runners;
			},
			raceType(){

				let type = '';

				switch (this.details.type) {
					case 'H':
						//meeting.racetype

						switch (this.snakeCase(this.details.racetype)) { //Don't want to deal with french letters
							case 'attele':
								type = 'icon--r-trotting';
								break;
							case 'monte':
								type = 'icon--r-trot';
								break;
							default:
								type = 'icon--r-trot';
								break;
						}

						break;
					case 'T':

						switch (this.snakeCase(this.details.racetype)) { //Don't want to deal with french letters
							case 'haies':
								type = 'icon--r-hurdle';
								break;
							case 'plat':
								type = 'icon--r-gallop';
								break;
							default:
								type = 'icon--r-gallop';
								break;
						}
						break;
				}

				return type;
			}
		},
		watch: {},
		mounted() {

		},
		methods: {

		}
	}
</script>
<style lang="scss">

</style>